/**
 * Ball component simply renders a ball at a specific position.
 */

import React from 'react';


class BallComponent extends React.Component {

  render () {
    let classes = 'ball';
    classes += ' position-' + this.props.position;
    classes += this.props.isUp ? ' up' : ' down';
    const image = this.props.hiddenItemImage || "assets/images/ball.png";
    return (
      <div className={classes}>
        <img src={image} />
      </div>
    )
  }

}

export default BallComponent;
